// src/pages/NotFoundPage.tsx
//
// ★★ WAVE 24 — this was the ONLY page of the thirty-nine with no heading at all.
//
// It rendered a bare `<p>Page not found.</p>` inside the Shell. Two consequences,
// both real rather than theoretical:
//
//   * A screen-reader user navigating by heading landed on a page whose outline
//     was empty — the shell's `h2` rail heading was the deepest thing there, and
//     the `<main>` had nothing. Every other page in the app has exactly one `h1`.
//   * It never said WHICH address failed. An officer following a stale link or a
//     mistyped bookmark was told only that "there is no screen at this address",
//     with the address itself nowhere on the page — so they could not tell a typo
//     from a screen that had moved, and had nothing to quote into a support ticket.
import { Link, useLocation } from 'react-router'
import { useCrumbTitle } from '../lib/crumbs'

export function NotFoundPage() {
  useCrumbTitle('Page not found')
  const location = useLocation()
  return (
    <div className="pt-card max-w-md mx-auto mt-16 text-center">
      <h1 className="text-2xl font-semibold">Page not found</h1>
      <p className="mt-2 text-[var(--sgds-body-color-subtle)]">
        There is no screen at{' '}
        {/*
          ⚠ The path only — never `location.search`. A query string on this
          product's screens carries officer ids, card numbers and scheme codes,
          and echoing an unmatched URL's query back into the page would put a
          classified identifier on screen and into any screenshot of it. The path
          is what identifies the missing screen; the rest is not needed to say so.
        */}
        <code className="pt-mono">{location.pathname}</code>.
      </p>
      <p className="mt-2 text-[var(--sgds-body-color-subtle)]">
        The link may be out of date, or the screen may not be part of your role.
      </p>
      <Link to="/dashboard" className="inline-block mt-4 font-semibold">
        Go to processing overview
      </Link>
    </div>
  )
}
